import './newsletter-distributions.component.css'

const newsletterDistributionConfig = {
    selector: 'mwNewsletterDistributions',
    // GYDA-32355 - Tier 3 Fix - Begins
    template: `
        <md-toolbar id="distributionBackButton" class="mw-page-header">
            <div class="md-toolbar-tools">
                <md-button aria-label="{{$ctrl.$translate.instant('Back')}}" class="mw-button md-icon-button" ng-click="$ctrl.onBackClick()">
                    <md-icon md-svg-icon="navigation:ic_arrow_back_24px"></md-icon>
                </md-button>
                <span ng-if="!$ctrl.NewsletterDistributionService.isLoading" flex>{{$ctrl.NewsletterDistributionService.newsletter.name}}</span>
            </div>
        </md-toolbar>
        <section layout="column" id="mw-newsletter-distributions-table__content" class="mw-flex-padding">
            <div class="distributionSchedule" ng-if="!$ctrl.NewsletterDistributionService.isLoading && $ctrl.NewsletterDistributionService.isRecurringNewsletter">
                {{$ctrl.calculateSchedule($ctrl.NewsletterDistributionService.newsletter)}}
            </div>
            <mw-newsletter-distribution-data-table ng-if="!$ctrl.isCardListVisible" on-show-cards="$ctrl.onChangeView()"></mw-newsletter-distribution-data-table>
            <md-button aria-label="Add" class="mw-fab md-fab md-fab-bottom-right mw-fab--fixed" ng-click="$ctrl.onFabClick()" ng-if="$ctrl.showFab()">
                <md-icon md-svg-src="content:ic_add_24px"></md-icon>
                <md-tooltip md-direction="left">
                    <span translate>mw-newsletter-data-table__action-create-distribution</span>
                </md-tooltip>
            </md-button>
        </section>
    `,
    // GYDA-32355 - Tier 3 Fix - Ends
    controller: null
};

class NewsletterDistributionComponent {
    selectedItem: any;
    items: any[];
    isCardListVisible: boolean;

    constructor(
        private $window,
        private NewsletterDistributionService,
        private $location,
        private $routeParams,
        private AppBarTitleService,
        private $translate
    ) {
        'ngInject';
        this.isCardListVisible = false;
        this.selectedItem = {};
    }

    $onInit() {
        this.AppBarTitleService.setCurrentTitle(this.$translate.instant('Outputs'));
    }

    $onDestroy() {
        this.NewsletterDistributionService.resetNLDDataTable();
    }

    showFab() {
        return !(this.NewsletterDistributionService.isRecurringNewsletter || this.NewsletterDistributionService.isOneOffNewsletter);
    }

    onBackClick($event) {
        this.$location.url('/outputs/newsletters');
    }

    onFabClick($event) {
        this.$location.url('/newsletter/' + this.$routeParams.outputId + '/distribution/create');
    }

    onChangeView() {
        this.isCardListVisible = !this.isCardListVisible;
        this.resetTableScroll();
    }

    resetTableScroll() {
        var element = this.$window.document.getElementById('mw-newsletter-distributions-table__content');
        if (element) {
            element.scrollTop = 0;
        }
    };

    calculateSchedule(newsletter) {
        return newsletter && newsletter.settings && newsletter.settings.paused
            ?
            this.$translate.instant('newsletter__distributions--next-distribution-paused-message')
            :
            this.$translate.instant('mw-newsletter-next-distribution-schedule__content', {scheduleDate: this.NewsletterDistributionService.nextSchedule});
    }
}

newsletterDistributionConfig.controller = NewsletterDistributionComponent;

export {
    newsletterDistributionConfig,
    NewsletterDistributionComponent as default
};



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/newsletter-distributions/newsletter-distributions.component.ts
 **/